const allowedStripeHosts = new Set(['checkout.stripe.com', 'buy.stripe.com']);

// Client-side post-auth redirect validation. Same-site paths pass through;
// absolute URLs only for https Stripe checkout or the current origin.
export const getSafeRedirect = (value: string | null) => {
    if (!value) return '/dashboard';
    // "//evil.com" (and the "/\" variant) is protocol-relative, not a local
    // path — router.replace would resolve it to https://evil.com.
    if (value.startsWith('//') || value.startsWith('/\\')) return '/dashboard';
    if (value.startsWith('/')) return value;
    try {
        const url = new URL(value);
        if (url.protocol !== 'https:') return '/dashboard';
        if (allowedStripeHosts.has(url.hostname)) return url.toString();
        if (typeof window !== 'undefined' && url.origin === window.location.origin) {
            return `${url.pathname}${url.search}${url.hash}`;
        }
    } catch {
        return '/dashboard';
    }
    return '/dashboard';
};
